import React from 'react';
import values from 'lodash.values';
import some from 'lodash.some';
import { connect } from 'react-redux';
import { SHOP_OPENED_MODE_HOLIDAY } from '@chama/utils/constants/status';
import { toggleFilter } from '@app/actions/dealers';
import MdtStatusLayout from '@chama/ui-components/components/MdtStatusLayout';

const MdtStatus = props => {
  return <MdtStatusLayout {...props} />;
};

const mapStateToProps = state => {
  const {
    dealer: { all, filteredAll, filters, numberOfBuckets },
  } = state;
  const dealerList = values(all);
  const isHolidayMode = some(
    dealerList,
    dealer => dealer.isOpenedMode === SHOP_OPENED_MODE_HOLIDAY,
  );

  return {
    filteredDealersList: values(filteredAll),
    filters,
    numberOfBuckets,
    isHolidayMode,
  };
};

export default connect(
  mapStateToProps,
  { toggleFilter },
)(MdtStatus);



// WEBPACK FOOTER //
// ./src/containers/MdtStatus.jsx